import { APEXEnvironment } from '../app/utils/types';

export const environment: APEXEnvironment = {
  staging: false,
  production: true,
  test: false,
  assetsUrl: 'https://app.apexapp.io/assets',
  api: 'https://api.apexapp.io',
  restApi: 'https://rest.apexapp.io',
  appUrl: 'https://app.apexapp.io',
  apexUrl: 'https://apexit.apexapp.io',
  inspectionUrl: 'https://inspection.apexapp.io',
  reportingUrl: 'https://reporting.apexapp.io',
  portalUrl: 'https://portal.apexapp.io',
  printUrl: 'https://print.apexapp.io',
  requestsUrl: 'https://requests.apexapp.io',
  bucket: 'files.apexapp.io',
  bucketUrl: 'https://files.apexapp.io',
  pdfViewerUrl: 'https://pdfviewer.apexapp.io',
  pdfWorkerSrc: 'https://app.apexapp.io/assets/libs/pdf.worker.min.js',

  logoutUrl: 'https://apexit.apexapp.io/logout',

  transifexToken: '1/d21a0676ec72779a598b876fbf7c422f776a6e70',

  oAuthCallbackUrl: 'https://api.apexapp.io/user/auth/code',

  pusherInstanceId: '0793a8ae-d3e8-4935-9bae-91f0c3831b76',
};
